import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./App.css";

function Home() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.9;
    }
  }, []);
  return (
    <div className="page-container">
      {/* 1. Hero Section */}
      <header className="hero-section">
        <div className="video-overlay"></div>
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="hero-video"
        >
          <source src="/docvid.mov" type="video/mp4" />
        </video>
        <div className="hero-content">
          <h1 className="fade-in-up">DR. SUNIL KUMAR SINGH BHADOURIYA</h1>
          <h2 className="fade-in-up delay-1">
            EAR, THROAT, NOSE CONSULTANT AND SURGEON
          </h2>
          <p className="hero-tagline fade-in-up delay-2">
            Where Medical Expertise Meets Human Compassion.
          </p>

          <div className="hero-buttons fade-in-up delay-3">
            <Link to="/contact" className="cta-button primary pulse-effect">
              Book Appointment Now
            </Link>
            <Link to="/services" className="cta-button secondary">
              Explore Services
            </Link>
          </div>
        </div>
      </header>

      {/* 2. Quick Stats Strip */}
      <section className="stats-strip">
        <div className="stat-item">
          <span className="stat-number">20+</span>
          <span className="stat-label">Years Experience</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">5k+</span>
          <span className="stat-label">Surgeries Performed</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">10k+</span>
          <span className="stat-label">Happy Patients</span>
        </div>
      </section>

      {/* 3. Meet the Doctor (Profile) */}
      <section className="home-section">
        <div className="container">
          <h2 className="section-title">Meet Our Extraordinary</h2>

          <div className="profile-grid">
            {/* Doctor Profile */}
            <div className="profile-card">
              <div className="image-placeholder portrait">
                <img
                  src="/docpho.jpg"
                  alt="Dr. Sunil Kumar Singh"
                  className="profile-img portrait"
                />
              </div>
              <div className="profile-text">
                <h3>A Legacy of Healing</h3>
                <p>
                  Dr. Sunil Kumar Singh is not just a consultant; he is a
                  pioneer in ENT care. He combines technical expertise with a
                  gentle touch.He is also packed with a bunch of experiences and
                  have a mastery with how the patients feel
                </p>
                <Link to="/extraordinary" className="text-link">
                  Read more about his philosophy →
                </Link>
              </div>
            </div>

            {/* --- NEW SURGERY SECTION ADDED HERE --- */}
            <div className="profile-card reverse">
              <div className="profile-text">
                <h3>Surgical Precision</h3>
                <p>
                  Surgery is an art, and Dr. Singh is a master artist.
                  Specializing in complex procedures with minimal invasiveness,
                  his surgical hands have restored the senses of hundreds of
                  patients. From Tympanoplasty to FESS, he combines technical
                  expertise with steady hands to deliver safe outcomes.
                </p>
                <Link to="/services" className="text-link">
                  View Surgical Procedures →
                </Link>
              </div>
              <div className="image-placeholder landscape">
                <img
                  src="/sur.jpg"
                  alt="Dr. Sunil Kumar Singh"
                  className="profile-img portrait"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Why Choose Us */}
      <section className="home-section alt-bg">
        <div className="container">
          <h2 className="section-title">Why Choose Dr. Singh?</h2>
          <div className="features-grid">
            <div className="feature-box">
              <div className="icon">🏥</div>
              <h3>Patients Review</h3>
              <p>Tons of Medical Relivant Review</p>
            </div>
            <div className="feature-box">
              <div className="icon">🔬</div>
              <h3>Advanced Tech</h3>
              <p>Using the latest minimally invasive surgical equipment.</p>
            </div>
            <div className="feature-box">
              <div className="icon">🤝</div>
              <h3>Personal Care</h3>
              <p>We treat the patient, not just the disease.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Patient Testimonials */}
      <section className="home-section">
        <div className="container">
          <h2 className="section-title">Patient Stories</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>
                "I was suffering from chronic sinusitis for years. Dr. Singh's
                diagnosis was spot on. I can finally breathe freely!"
              </p>
              <h4>- Rajesh Verma</h4>
            </div>
            <div className="testimonial-card">
              <p>
                "The best ENT surgeon in Greater Noida. Very polite and explains
                everything clearly before the procedure."
              </p>
              <h4>- Anjali Gupta</h4>
            </div>
            <div className="testimonial-card">
              <p>
                "Extraordinary doctor. He treated my son's ear infection very
                gently. Highly recommended."
              </p>
              <h4>- Amit Kumar</h4>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to feel better?</h2>
        <p>Don't let ENT issues hold you back.</p>
        <Link to="/contact" className="cta-button primary big-btn">
          Schedule Your Visit
        </Link>
      </section>
    </div>
  );
}

export default Home;
